<div class="payment-method-form">
  <!-- Payment Method Type -->
  <div class="form-field mb-4">
    <label for="payment-type" class="block text-sm font-medium mb-2">
      Payment Method Type
    </label>
    <p-select
      inputId="payment-type"
      [(ngModel)]="paymentMethod.Type"
      [options]="paymentTypeOptions"
      (onChange)="onPaymentTypeChange()"
      [disabled]="disabled || isLoading"
      [loading]="isLoading"
      placeholder="Select payment method type"
      styleClass="w-full"
    />
    @if (paymentMethod.Type === "Other") {
      <small class="text-orange-600 block mt-1">
        Selecting "Other" will process the Orders without making any Charges!
      </small>
    }
  </div>

  <!-- Token ID (PayPal V2 only) -->
  @if (paymentMethod.Type === "PaypalV2") {
    <div class="form-field mb-4">
      <label for="token-id" class="block text-sm font-medium mb-2">
        Token ID
      </label>
      <input
        pInputText
        id="token-id"
        [(ngModel)]="paymentMethod.GatewayPaymentId"
        (ngModelChange)="emitChanges()"
        [disabled]="disabled"
        placeholder="Enter token ID"
        class="w-full"
      />
    </div>
  }

  <!-- Payment Gateway Type (Stripe and PayPal) -->
  @if (
    paymentMethod.Type === "Stripe" ||
    paymentMethod.Type === "PayPal" ||
    paymentMethod.Type === "PaypalV2" ||
    paymentMethod.Type === "PayPalV3"
  ) {
    <div class="form-field mb-4">
      <label for="gateway-type" class="block text-sm font-medium mb-2">
        Payment Gateway Type
      </label>
      <p-select
        inputId="gateway-type"
        [(ngModel)]="paymentMethod.GatewayPaymentType"
        [options]="gatewayPaymentTypeOptions"
        (onChange)="emitChanges()"
        [disabled]="disabled"
        placeholder="Select gateway payment type"
        styleClass="w-full"
      />
    </div>
  }

  <!-- Gateway Customer ID (all except PayPal V2) -->
  @if (paymentMethod.Type && paymentMethod.Type !== "PaypalV2") {
    <div class="form-field mb-4">
      <label for="gateway-customer-id" class="block text-sm font-medium mb-2">
        Gateway Customer ID
      </label>
      <input
        pInputText
        id="gateway-customer-id"
        [(ngModel)]="paymentMethod.GatewayCustomerId"
        (ngModelChange)="emitChanges()"
        [disabled]="disabled"
        placeholder="Enter gateway customer ID"
        class="w-full"
      />
    </div>
  }

  <!-- Gateway Payment ID (all except PayPal V2) -->
  @if (paymentMethod.Type && paymentMethod.Type !== "PaypalV2") {
    <div class="form-field mb-4">
      <label for="gateway-payment-id" class="block text-sm font-medium mb-2">
        Gateway Payment ID
      </label>
      <input
        pInputText
        id="gateway-payment-id"
        [(ngModel)]="paymentMethod.GatewayPaymentId"
        (ngModelChange)="emitChanges()"
        [disabled]="disabled"
        placeholder="Enter gateway payment ID"
        class="w-full"
      />
    </div>
  }

  <!-- Payment Method Description -->
  <div class="form-field mb-4">
    <label for="description" class="block text-sm font-medium mb-2">
      Payment Method Description
    </label>
    <input
      pInputText
      id="description"
      [(ngModel)]="paymentMethod.Description"
      (ngModelChange)="emitChanges()"
      [disabled]="disabled"
      placeholder="Enter description"
      class="w-full"
    />
  </div>

  <!-- Divider -->
  <p-divider />

  <!-- Billing Information Header -->
  <div class="mb-4">
    <h3 class="text-lg font-semibold">Billing Information</h3>
    <p class="text-sm text-gray-600 mt-1">
      Enter the billing address for this payment method
    </p>
  </div>

  <!-- Billing Fields Grid -->
  <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
    <!-- Billing First Name -->
    <div class="form-field">
      <label for="billing-first-name" class="block text-sm font-medium mb-2">
        First Name
      </label>
      <input
        pInputText
        id="billing-first-name"
        [(ngModel)]="paymentMethod.BillingFirstName"
        (ngModelChange)="emitChanges()"
        [disabled]="disabled"
        placeholder="Enter first name"
        class="w-full"
      />
    </div>

    <!-- Billing Last Name -->
    <div class="form-field">
      <label for="billing-last-name" class="block text-sm font-medium mb-2">
        Last Name
      </label>
      <input
        pInputText
        id="billing-last-name"
        [(ngModel)]="paymentMethod.BillingLastName"
        (ngModelChange)="emitChanges()"
        [disabled]="disabled"
        placeholder="Enter last name"
        class="w-full"
      />
    </div>

    <!-- Billing Country (Full Width) -->
    <div class="form-field md:col-span-2">
      <label for="billing-country" class="block text-sm font-medium mb-2">
        Country
      </label>
      <app-country-select
        [(ngModel)]="paymentMethod.BillingCountry"
        (selectionChange)="onBillingCountryChange($event)"
        [disabled]="disabled"
        [required]="true"
        placeholder="Select billing country"
      />
    </div>

    <!-- Billing Street 1 (Full Width) -->
    <div class="form-field md:col-span-2">
      <label for="billing-street1" class="block text-sm font-medium mb-2">
        Street Address 1
      </label>
      <input
        pInputText
        id="billing-street1"
        [(ngModel)]="paymentMethod.BillingStreet1"
        (ngModelChange)="emitChanges()"
        [disabled]="disabled"
        placeholder="Enter street address"
        class="w-full"
      />
    </div>

    <!-- Billing Street 2 (Full Width) -->
    <div class="form-field md:col-span-2">
      <label for="billing-street2" class="block text-sm font-medium mb-2">
        Street Address 2
      </label>
      <input
        pInputText
        id="billing-street2"
        [(ngModel)]="paymentMethod.BillingStreet2"
        (ngModelChange)="emitChanges()"
        [disabled]="disabled"
        placeholder="Apartment, suite, etc. (optional)"
        class="w-full"
      />
    </div>

    <!-- Billing City -->
    <div class="form-field">
      <label for="billing-city" class="block text-sm font-medium mb-2">
        City
      </label>
      <input
        pInputText
        id="billing-city"
        [(ngModel)]="paymentMethod.BillingCity"
        (ngModelChange)="emitChanges()"
        [disabled]="disabled"
        placeholder="Enter city"
        class="w-full"
      />
    </div>

    <!-- Billing State (US) / Text Input (Other Countries) -->
    <div class="form-field">
      <label for="billing-state" class="block text-sm font-medium mb-2">
        State / Province
      </label>

      @if (paymentMethod.BillingCountry === "US") {
        <!-- US State Selector -->
        <app-state-select
          [(ngModel)]="paymentMethod.BillingState"
          (selectionChange)="onBillingStateChange($event)"
          [disabled]="disabled"
          [required]="true"
          placeholder="Select state"
        />
      } @else {
        <!-- Text Input for Non-US Countries -->
        <input
          pInputText
          id="billing-state"
          [(ngModel)]="paymentMethod.BillingState"
          (ngModelChange)="emitChanges()"
          [disabled]="disabled"
          placeholder="Enter state or province"
          class="w-full"
        />
      }
    </div>

    <!-- Billing Postcode -->
    <div class="form-field md:col-span-2">
      <label for="billing-postcode" class="block text-sm font-medium mb-2">
        Postal / ZIP Code
      </label>
      <input
        pInputText
        id="billing-postcode"
        [(ngModel)]="paymentMethod.BillingPostcode"
        (ngModelChange)="emitChanges()"
        [disabled]="disabled"
        placeholder="Enter postal code"
        class="w-full"
      />
    </div>
  </div>
</div>
